<template>
    <div class="mindar-ui-overlay mindar-ui-scanning">
        <div class="scanning">
            <div class="inner">
                <div class="scanline"></div>
            </div>
        </div>
        <div class="tip"><span>请将摄像机对准单个产品的正面进行扫描</span></div>

    </div>
</template>


<style lang="scss" scoped>
$primary-color: #fff;
$scan-mask-border: 10px;
.mindar-ui-overlay {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: transparent;
    z-index: 2;
    z-index: 999;

    &.hidden {
        display: none;
    }
}


.mindar-ui-scanning {
    .scanning {
        @media (min-aspect-ratio: 1) {
            width: 50vh;
            height: 50vh;
        }

        @media (max-aspect-ratio: 1) {
            width: 80vw;
            height: 80vw;
        }

        .inner {
            position: relative;
            width: 100%;
            height: 100%;
            opacity: 0.8;

            background:
                linear-gradient(to right, $primary-color $scan-mask-border, transparent $scan-mask-border) 0 0,
                linear-gradient(to right, $primary-color $scan-mask-border, transparent $scan-mask-border) 0 100%,
                linear-gradient(to left, $primary-color $scan-mask-border, transparent $scan-mask-border) 100% 0,
                linear-gradient(to left, $primary-color $scan-mask-border, transparent $scan-mask-border) 100% 100%,
                linear-gradient(to bottom, $primary-color $scan-mask-border, transparent $scan-mask-border) 0 0,
                linear-gradient(to bottom, $primary-color $scan-mask-border, transparent $scan-mask-border) 100% 0,
                linear-gradient(to top, $primary-color $scan-mask-border, transparent $scan-mask-border) 0 100%,
                linear-gradient(to top, $primary-color $scan-mask-border, transparent $scan-mask-border) 100% 100%;

            background-repeat: no-repeat;
            background-size: 40px 40px;

            .scanline {
                position: absolute;
                width: 100%;
                height: 10px;
                background: $primary-color;
                animation: move 2s linear infinite;

                @keyframes move {

                    0%,
                    100% {
                        top: 0%
                    }

                    50% {
                        top: calc(100% - 10px)
                    }
                }
            }
        }
    }

    .tip {
        position: absolute;
        left: 50%;
        top: 10vh;
        transform: translateX(-50%);
        font-size: 14px;
        font-weight: 500;
        letter-spacing: 1px;
        text-shadow: 0px 0px 6px rgba(0, 0, 0, 0.6);
        
        padding: 4px;
        color: white;
        z-index: 400;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        span{
            background-color: rgba(0, 0, 0, 0.6);
            padding: 8px;
            border-radius: 8px;
        }

        @media (max-aspect-ratio: 1) {
            top: 10vh;
        }

        @media (min-aspect-ratio: 1) {
            top: 5vh;
        }

    }

}
</style>